import React from 'react';
import { ReactElement } from 'react';
import InstanceModeSwitch from '../InstanceModeSwitch';

export const SwitchZahlweise = (props: { children: ReactElement }) => {
  return <InstanceModeSwitch disable={'kv'}>{props.children}</InstanceModeSwitch>;
};
